import CrudService from "services/cruds-service";

export const getPermissions = async (id,routes) => {
  try {
    const res = await CrudService.getUserWithPermissions(id);
    const permissions = res.included;
    let iconWithPermissionsMap = new Map();
    res.userPermissions.filter((permission) => permission.icon_id).forEach((permission) => {
      let name = permission.name.split(" ")[1];
      iconWithPermissionsMap.set(name, {
        name: permission.name,
        icon: permission.Icon.class_name,
      });
    });
    let jsonPermissions = [];
    permissions.map((permission) => {
      if (permission.type == "permissions") {
        const namePermission = permission.attributes.name.split(" ");
        if (namePermission.length === 2) {
          const action = namePermission[0];
          const subject = namePermission[1];
          if ((action === "delete" || action === "edit") && subject === "users") {
            jsonPermissions = [
              ...jsonPermissions,
              { action, subject, conditions: { id: { $ne: id } } },
            ];
          } else {
            jsonPermissions = [...jsonPermissions, { action, subject }];
          }
        }
      }
    });
    let newRoutes = []
    routes.map((route) => {
      if (iconWithPermissionsMap.get(route.key)) {
        newRoutes.push({
          ...route,
          icon: <i className={iconWithPermissionsMap.get(route.key).icon}></i>
        })
      } else {
        newRoutes.push(route)
      }
    })
    return {rules: jsonPermissions, newRoutes: newRoutes};
  } catch (err) {
    console.error(err);
    return null;
  }
};
